import React, { useEffect, useState } from 'react'
import { Price } from 'lib/shared/components'
import { Link } from 'react-router-dom'
import { ReactComponent as EditSvg } from 'resources/svg/icons/edit.svg'
import { EditForm } from './components/EditForm'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'
import { subscriptionItem } from '../../scenes/Details'
import { useProductBySku } from 'lib/modules/catalog'

interface Props {
  subscriptionProduct: any
  setSubscriptionItemsChanges: (params: any) => void
  subscriptionItemsChanges: subscriptionItem[]
}

export const PRODUCT_IMAGE_URL = `${process.env.REACT_APP_MAGENTO_URI}/media/catalog/product`

export const ProductItem: React.FC<Props> = ({ subscriptionProduct, subscriptionItemsChanges, setSubscriptionItemsChanges }) => {
  const [isFormOpen, setIsFormOpen] = useState<boolean>(false)
  const { sku, qty, frequency_in_cart: frequencyInCart, price } = subscriptionProduct ?? {}
  const frequencyInWeeks = frequencyInCart / 7
  const [quantity, setQuantity] = useState(Math.round(qty))
  const [frequency, setFrequency] = useState<number>(frequencyInWeeks)
  const { product } = useProductBySku({ sku })

  useEffect(() => {
    const newItems = [{ sku, quantity, frequency }, ...subscriptionItemsChanges]
    const uniqueItems = newItems.filter((v, i, a) => a.findIndex(t => (t.sku === v.sku))===i)
    setSubscriptionItemsChanges(uniqueItems)
    // eslint-disable-next-line
  }, [quantity, frequency])

  if (!subscriptionProduct) {
    return null
  }

  const {
    image,
    name,
    customAttribute
  } = product ?? {}

  const imageUrl = image?.default.url ?? `${PRODUCT_IMAGE_URL}${subscriptionProduct.thumbnail}`
  const [packageQty] = customAttribute?.package_qty ?? []
  const [packageType] = customAttribute?.package ?? []

  return (
    <div
      key={subscriptionProduct.sku}
      className='subscription__content'
    >
      <div className='subscription__item'>
        <div className='item__info'>
          <div className='item__image'>
            <span
              style={{ backgroundImage: `url(${imageUrl})` }}
            />
          </div>
          <div>
            <div className='item__name'>
              {name ?? subscriptionProduct?.name}
            </div>
            <div className='item__shipment'>
              <span>Next shipment {subscriptionProduct.nextShipment}</span>
            </div>
            <div className='item__pack'>
              <span>{quantity} {packageType} of {packageQty ?? subscriptionProduct?.package_qty} pieces.</span>
            </div>
          </div>
        </div>
        <div className='item__price'>
          <Price currency={DEFAULT_CURRENCY_CODE} value={price} />
        </div>
        <div className='item__extra'>
          <div>
            <span>Find your perfect product</span>
            <Link to='/product-selector'>
              <EditSvg />
            </Link>
          </div>
          <div>
            <span>Edit subscription details</span>
            <span className='edit' onClick={() => setIsFormOpen(!isFormOpen)}>
              <EditSvg />
            </span>
          </div>
        </div>
      </div>
      {isFormOpen && (
        <EditForm
          setQuantity={setQuantity}
          quantity={quantity}
          frequency={frequency}
          setFrequency={setFrequency}
        />
      )}
    </div>
  )
}
